<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('mainCategory.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="mainCategoryManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="mainCategoryManageInfo.conditions.categoryName"
              :placeholder="$t('mainCategory.inputCategoryName')" clearable />
          </el-form-item>
          <el-form-item>
          <el-input v-model="mainCategoryManageInfo.conditions.mainCategoryId"
            :placeholder="$t('mainCategory.inputCategoryId')" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="mainCategoryManageInfo.conditions.statusCd"
            :placeholder="$t('mainCategory.status')"
            clearable>
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('mainCategory.status0')" value="0" />
            <el-option :label="$t('mainCategory.status1')" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryMainCategoryMethod">
            {{ $t('mainCategory.query') }}
          </el-button>
        </el-form-item>
<!--            <el-input v-model="mainCategoryManageInfo.conditions.mainCategoryId"
              :placeholder="$t('mainCategory.inputCategoryId')" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryMainCategoryMethod">
              {{ $t('mainCategory.query') }}
            </el-button>
          </el-form-item>-->
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('mainCategory.productCategory') }}</span>
        <el-button type="primary" size="small" style="float: right" @click="_openAddMainCategoryModal">
          <i class="el-icon-plus"></i>
          {{ $t('mainCategory.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="mainCategoryManageInfo.mainCategorys" border style="width: 100%">
          <el-table-column prop="mainCategoryId" :label="$t('mainCategory.categoryId')" align="center" />
          <el-table-column prop="categoryName" :label="$t('mainCategory.categoryName')" align="center" />
          <el-table-column prop="startTime" :label="$t('mainCategory.startTime')" align="center" />
          <el-table-column prop="endTime" :label="$t('mainCategory.endTime')" align="center" />
          <el-table-column prop="seq" :label="$t('mainCategory.seq')" align="center" />
          <el-table-column prop="categoryDesc" :label="$t('mainCategory.desc')" align="center" />

          <el-table-column prop="statusCd" :label="$t('mainCategory.status')" align="center">
            <template slot-scope="scope">
              {{ getStatusLabel(scope.row.statusCd) }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('mainCategory.operation')" align="center" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditMainCategoryModel(scope.row)">
                {{ $t('mainCategory.edit') }}
              </el-button>

              <el-button
                size="mini"
                :type="scope.row.statusCd === '0' ? 'danger' : 'success'"
                @click="_toggleStatus(scope.row)">
                {{ scope.row.statusCd === '0' ? $t('mainCategory.disable') : $t('mainCategory.enable') }}

<!--              <el-button size="mini" type="danger" @click="_openDeleteMainCategoryModel(scope.row)">
                {{ $t('mainCategory.delete') }}-->

              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next" :total="mainCategoryManageInfo.total" style="margin-top: 20px" />
      </div>
    </el-card>

    <add-main-category ref="addMainCategory" @refresh="queryMainCategoryMethod" />
    <edit-main-category ref="editMainCategory" @refresh="queryMainCategoryMethod" />
    <delete-main-category ref="deleteMainCategory" @refresh="queryMainCategoryMethod" />
  </div>
</template>

<script>
import { queryMainCategory, updateMainCategory } from '@/api/admin/mainCategory/mainCategoryApi'

import AddMainCategory from '@/components/admin/addMainCategory/addMainCategory'
import EditMainCategory from '@/components/admin/editMainCategory/editMainCategory'
import DeleteMainCategory from '@/components/admin/deleteMainCategory/deleteMainCategory'

export default {
  name: 'MainCategoryManage',
  components: {
    AddMainCategory,
    EditMainCategory,
    DeleteMainCategory
  },
  data() {
    return {
      mainCategoryManageInfo: {
        mainCategorys: [],
        total: 0,
        conditions: {
          categoryName: '',
          mainCategoryId: '',
          statusCd: ''

        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listMainCategorys(this.currentPage, this.pageSize)
  },
  methods: {
    queryMainCategoryMethod() {
      this.currentPage = 1
      this._listMainCategorys(this.currentPage, this.pageSize)
    },
    async _listMainCategorys(page, rows) {
      try {
        const params = {
          page,
          row: rows,
          ...this.mainCategoryManageInfo.conditions
        }
        const res = await queryMainCategory(params)
        this.mainCategoryManageInfo.mainCategorys = res.data
        this.mainCategoryManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryMainCategoryMethod() {
      this.currentPage = 1
      this._listMainCategorys(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listMainCategorys(this.currentPage, this.pageSize)
    },
    _openAddMainCategoryModal() {
      this.$refs.addMainCategory.open()
    },
    _openEditMainCategoryModel(row) {
      this.$refs.editMainCategory.open(row)
    },

    _toggleStatus(row) {
      const newStatus = row.statusCd === '0' ? '1' : '0'
      const confirmMsg = newStatus === '1' ? this.$t('mainCategory.confirmDisable') : this.$t('mainCategory.confirmEnable')

      this.$confirm(confirmMsg, this.$t('mainCategory.confirmOperation'), {
        confirmButtonText: this.$t('mainCategory.confirm'),
        cancelButtonText: this.$t('mainCategory.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          const params = { ...row, statusCd: newStatus }
          await updateMainCategory(params)
          this.$message.success(this.$t('mainCategory.editSuccess'))
          this.queryMainCategoryMethod()
        } catch (error) {
          console.error(error)
        }
      }).catch(() => {
        this.$message.info(this.$t('mainCategory.cancel'))
      })
    },
    getStatusLabel(status) {
      const statusMap = {
        '0': this.$t('mainCategory.status0'),
        '1': this.$t('mainCategory.status1')
      }
      return statusMap[status] || status

 /*   _openDeleteMainCategoryModel(row) {
      this.$refs.deleteMainCategory.open(row)*/

    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>
